import { Component, OnDestroy, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ActivatedRoute, Router } from '@angular/router';
import { PopupService } from '../../../shared/modal/popup.service';
import { HttpResponse } from '@angular/common/http';
import { TranslateService } from '@ngx-translate/core';
import { finalize } from 'rxjs/operators';
import { GermplasmAuditService } from '../germplasm-audit.service';
import { GermplasmAttributeAudit } from './germplasm-attribute-audit.model';
import { GermplasmAttributeContext } from '../../../entities/germplasm/attribute/germplasm-attribute.context';
import { getEventDate, getEventUser } from '../germplasm-audit-utils';
import { VariableTypeEnum } from '../../../shared/ontology/variable-type.enum';
import { GermplasmDetailsContext } from '../../germplasm-details.context';
import { GermplasmDetailsPopupService } from '../../germplasm-details-popup.service';
import { AlertService } from '../../../shared/alert/alert.service';
import { MAX_ATTRIBUTE_DISPLAY_SIZE } from '../../../app.constants';

@Component({
    selector: 'jhi-germplasm-attribute-audit',
    templateUrl: './germplasm-attribute-audit.component.html',
    styleUrls: [
        '../germplasm-audit.scss'
    ]
})
export class GermplasmAttributeAuditComponent implements OnInit, OnDestroy {

    protected readonly MAX_ATTRIBUTE_DISPLAY_SIZE = MAX_ATTRIBUTE_DISPLAY_SIZE;

    readonly itemsPerPage: number = 10;

    gid: number;
    attributeId: number;
    title: string;

    page: number;
    previousPage: number;
    totalItems: number;
    queryCount: number;
    isLoading: boolean;

    auditChanges: GermplasmAttributeAudit[];

    getEventDate = getEventDate;
    getEventUser = getEventUser;

    constructor(public activeModal: NgbActiveModal,
                private germplasmAuditService: GermplasmAuditService,
                private translateService: TranslateService,
                private germplasmAttributeContext: GermplasmAttributeContext,
                private alertService: AlertService,
                private activatedRoute: ActivatedRoute,
                private router: Router) {
        this.page = 1;

        let entity;
        if (this.germplasmAttributeContext.attributeType === VariableTypeEnum.GERMPLASM_PASSPORT) {
            entity = 'passport';
        } else if (this.germplasmAttributeContext.attributeType === VariableTypeEnum.GERMPLASM_ATTRIBUTE) {
            entity = 'attribute';
        }
        this.title = this.translateService.instant('audit.title',
            { param1: this.translateService.instant('audit.entities.' + entity), param2: this.germplasmAttributeContext.attribute.value });
    }

    ngOnInit(): void {
        this.loadAll();
    }

    loadPage(page: number) {
        if (page !== this.previousPage) {
            this.previousPage = page;
            this.transition();
        }
    }

    transition() {
        this.router.navigate(['germplasm/:gid/attribute/:attributeId/audit-dialog'], {
            queryParams:
                {
                    page: this.page,
                    size: this.itemsPerPage
                },
            relativeTo: this.activatedRoute,
            queryParamsHandling: 'merge'
        });
        this.loadAll();
    }

    dismiss() {
        this.activeModal.dismiss('cancel');
    }

    private loadAll() {
        this.isLoading = true;
        this.germplasmAuditService.getAttributeChanges(this.gid, this.attributeId, {
            page: this.page - 1,
            size: this.itemsPerPage
        }).pipe(finalize(() => {
            this.isLoading = false;
        })).subscribe(
            (res: HttpResponse<GermplasmAttributeAudit[]>) => this.onSuccess(res.body, res.headers)
        );
    }

    private onSuccess(data: GermplasmAttributeAudit[], headers) {
        this.totalItems = headers.get('X-Total-Count');
        this.queryCount = this.totalItems;
        this.auditChanges = data;
    }

    ngOnDestroy(): void {
        this.germplasmAttributeContext.attributeType = null;
        this.germplasmAttributeContext.attribute = null;
    }
}

@Component({
    selector: 'jhi-germplasm-attribute-audit-popup',
    template: ''
})
export class GermplasmAttributeAuditPopupComponent implements OnInit {

    constructor(private route: ActivatedRoute,
                private popupService: PopupService,
                private germplasmDetailsContext: GermplasmDetailsContext,
                private germplasmDetailsPopupService: GermplasmDetailsPopupService) {
    }

    ngOnInit(): void {
        const gid = Number(this.route.snapshot.paramMap.get('gid'));
        const attributeId = Number(this.route.snapshot.paramMap.get('attributeId'));

        if (this.germplasmDetailsContext.openedFromWorkbench) {
            this.germplasmDetailsPopupService.close();
        }

        const modal = this.popupService.open(GermplasmAttributeAuditComponent as Component, { modalDialogClass: 'modal-lg', backdrop: 'static' });
        modal.then((modalRef) => {
            modalRef.componentInstance.gid = gid;
            modalRef.componentInstance.attributeId = attributeId;

            if (this.germplasmDetailsContext.openedFromWorkbench) {
                modalRef.result.then((result) => {
                    this.germplasmDetailsPopupService.open(gid, 'attributes');
                }, () => {
                    this.germplasmDetailsPopupService.open(gid, 'attributes');
                });
            }
        });

    }

}
